exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".questions-page{font-family:'Montserrat', sans-serif;min-height:100vh;display:flex;flex-direction:column;flex-wrap:nowrap;justify-content:space-between}.questions-page .question-container{width:100%;padding:0 6rem;flex-grow:1;display:flex;flex-direction:column}.questions-page .question-container .answers-row{display:flex;flex-direction:row;justify-content:space-between}.questions-page .question-container .answers-row .answer{width:6.25rem;height:6.25rem}.questions-page .question-container .next-button-wrap{flex-grow:1;display:flex;flex-direction:row;justify-content:flex-end;align-items:flex-start;padding:5rem 0 10rem}.questions-page .question-container .next-button-wrap .next-button{color:#ffffff}.questions-page .question-container .next-button-wrap .next-button:disabled{background-color:rgba(0,0,0,0.6)}@media screen and (max-width: 350px){.questions-page .question-container .answers-row .answer{width:5rem;height:5rem}}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js?{"ident":"postcss","plugins":[null,null]}!./src/pages/Questionnaires/style.scss
// module id = 2108
// module chunks = 0